<template>
  <el-dialog
    v-el-drag-dialog
    :visible.sync="innerVisible"
    :title="$t('SeaExport.SelectOrderNumber')"
    width="1250px"
    append-to-body
    :close-on-click-modal="false"
    :before-close="beforeCloseHandler"
    class="app-main-inner search"
  >
    <div class="app-main-inner-row">
      <search-item
        config-module="100300"
        :reset="true"
        :show-simple="false"
        :expand-adv="true"
        :col-settings="{span:8}"
        :custom-search-items="customSearchItems"
        grid-config-module="1003001"
        @advSearchItemCallBack="toQuery"
        @perConfigChange="value=>{perConfigName=value}"
        @refreshGrid="()=>{gridRefreshId+=1}"
      />
    </div>
    <div class="app-main-inner-row">
      <cargo-ag-grid
        :grid-options="gridOptions"
        :column-defs="columnDefs"
        :row-data="rowData"
        style="min-height:300px"
        :per-config-name="perConfigName"
        :refresh-id="gridRefreshId"
        config-module="1310011"
        @gridReady="params=>{gridApi=params.api}"
      />
    </div>
    <div slot="footer" class="dialog-footer" style="justify-content: right">
      <el-button no="add" type="primary" @click="add">{{ $t('Message.Confirm') }}</el-button>
      <el-button no="cancel" @click="innerVisible=false">{{ $t('Message.Cancel') }}</el-button>
    </div>
  </el-dialog>
</template>

<script>

import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import cargoCompanySelect from '@/components/Cargo/Common/cargoCompanySelect'
import searchItem from '@/components/Cargo/Common/cargoCombinationSearch'
import ColumnUtils from '@/utils/ColumnUtils'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import URL from '@/api/urlTranslator'
import AdvancedSearchOption from '@/class/cargo/model/parameters/AdvancedSearchOption'
import AdvancedSearchConsts from '@/class/cargo/model/parameters/OperatorConstants'
import { queryJobs } from '@/api/booking/job'

export default {
  name: 'QueryJobDialog',
  components: { cargoAdvanceSelect, cargoCompanySelect, searchItem },
  props: {
    visible: { type: Boolean, required: true },
    lob: { type: String, required: true },
    job: { type: Object, required: true }
  },
  data() {
    return {
      innerVisible: false,
      selectTypeNames: TYPE_NAMES,
      URL,
      dischargingPortLock: false,
      perConfigName: '',
      gridRefreshId: 0,
      gridOptions: {
        rowSelection: 'multiple',
        suppressCellSelection: true,
        onRowDataChanged: event => {
          this.onRowDataChanged(event)
        },
        onSelectionChanged: event => {
          // 触发多选
          this.onMultipleSelected(event)
        },
        context: {
          componentParent: this
        }
      },
      rowData: [],
      selectedRows: [],
      gridApi: null,
      customSearchItems: [],
      joinSameGroupSlave: false,
      joinPersonSlave: false,
      departmentUsers: []
    }
  },
  computed: {
    columnDefs() {
      return [
        {
          headerName: '',
          field: '',
          width: 40,
          headerCheckboxSelection: true,
          checkboxSelection: true,
          sortable: false,
          suppressSizeToFit: true,
          resizable: false
        }, {
          headerName: this.$t('CargoMsg.Cargo_BusinessNo'),
          field: 'jobNo',
          width: 130
        }, {
          headerName: this.$t('CargoMsg.Cargo_AuthorizedClient'),
          field: 'customerId',
          width: 200,
          cellRenderer: params => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'chineseName')
          }
        }, {
          headerName: this.$t('SeaExport.PortOfLoadingAI'),
          field: 'loadingPortCode',
          width: 200,
          cellRenderer: params => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Seaport, 'code', params.value, 'englishName')
          }
        }, {
          headerName: this.$t('SeaExport.PortOfDestination'),
          field: 'dischargingPortCode',
          width: 200,
          cellRenderer: params => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Seaport, 'code', params.value, 'englishName')
          }
        }, {
          headerName: this.$t('SeaExport.DateOfDeparture'),
          field: 'etd',
          width: 200,
          cellRenderer: params => {
            return ColumnUtils.formateDateToString(params.value, 'yyyy-MM-dd')
          }
        }
      ]
    }
  },
  watch: {
    visible(newVal) {
      this.innerVisible = newVal
    },
    innerVisible(newVal) {
      if (!newVal) {
        this.rowData = []
        this.selectedRows = []
      }
      this.$emit('update:visible', newVal)
    }
  },
  methods: {
    toQuery(data) {
      if (typeof data === 'undefined' || !data || data.length === 0) {
        data = []
      }
      if (this.lob) {
        data.push(new AdvancedSearchOption(null, 'job.LOB', this.lob, AdvancedSearchConsts.OPERATOR_EQUAL.code).formatObj2Json())
      }
      data.push(new AdvancedSearchOption(null, 'job.MASTER_FLAG', this.job.masterFlag, AdvancedSearchConsts.OPERATOR_EQUAL.code).formatObj2Json())
      queryJobs({ conditions: data, branchId: this.$store.getters.currentOfficeId }).then(res => {
        this.rowData = res.data ? res.data.list : []
      })
    },
    onRowDataChanged(event) {
      // 重置（多选）选中行
      this.selectedRows = []
    },
    onMultipleSelected() {
      this.selectedRows = this.gridApi.getSelectedRows()
    },
    async add() {
      const selectedRows = this.selectedRows // 记录当前选中的记录，避免后续被修改
      if (selectedRows.length === 0 || selectedRows.length > 1) {
        this.$message.info(this.$t('CargoMsg.Cargo_HasOneOnly'))
        return
      }
      const triggerCallback = () => {
        this.$emit('callback', selectedRows[0])
        this.innerVisible = false
      }
      triggerCallback()
    },
    beforeCloseHandler() {
      this.$confirm(this.$t('Message.CancelTheCurrentQuery'), this.$t('CargoMsg.Cargo_ConfirmR'), {
        confirmButtonText: this.$t('common.btn.yes'),
        cancelButtonText: this.$t('common.btn.no'),
        closeOnClickModal: false,
        type: 'warning'
      }).then(() => {
        this.innerVisible = false
      }).catch(() => {
      })
    }
  }
}
</script>

<style lang="scss">
</style>
